import { useAccountRepository } from '@frontend/repository';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

import { useAppDispatch } from '../../../redux/store';
import { useIsMount } from '../../../utils/hooks';

export const useShipments = () => {
    const dispatch = useAppDispatch();
    const { currentAccount } = useAccountRepository();
    const listId = 'laundry-shipments-list';
    const navigate = useNavigate();
    const location = useLocation();
    const isMount = useIsMount();
    const [searchParams, setSearchParams] = useSearchParams();

    const [activeTab, setActiveTab] = useState<string>('incoming');

    useEffect(() => {
        if (isMount) {
            return;
        } else {
            setSearchParams((prev) => {
                const params = new URLSearchParams();
                params.set('tab', activeTab);
                return params;
            });
        }
    }, [activeTab]);

    return {
        listId,
        dispatch,
        currentAccount,
        activeTab,
        setActiveTab,
        navigate,
        location
    };
};
